import { render, staticRenderFns } from "./IncidentRiskTypeForm.vue?vue&type=template&id=69d46b3c"
import script from "./IncidentRiskTypeForm.vue?vue&type=script&lang=js"
export * from "./IncidentRiskTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports